// removed by extract-text-webpack-plugin
module.exports = {"container":"_3L3UZ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-page-layout/post-page-layout.scss
// module id = 1566
// module chunks = 0